module.exports = __webpack_public_path__ + "img/gai3.62590eda.jpg";